
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy/learn-ido",
      function () {
        return require("private-next-pages/academy/learn-ido/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academy/learn-ido"])
      });
    }
  